<template>
  <div v-if="!isDismissable || open" class="alert" :class="`alert-${type}`">
    <slot name="icon">
      <span v-if="withIcon" class="mi alert__icon" :class="`mi-${alertTypeToIcon[type]}`"></span>
    </slot>
    <div class="alert__content">
      <slot> </slot>
    </div>
    <a
      v-if="isDismissable"
      role="button"
      href="#"
      class="alert__close"
      @click.prevent="handleDismiss"
    >
      <span class="mi mi-cross"></span>
    </a>
  </div>
</template>

<script>
const ALERT_WARNING = 'warning';
const ALERT_INFO = 'info';
const ALERT_SUCCESS = 'success';

const alertTypes = [
  ALERT_WARNING,
  ALERT_INFO,
  ALERT_SUCCESS,
];

export default {
  name: 'CustomAlert',
  props: {
    open: {
      type: Boolean,
      default: null,
    },
    type: {
      type: String,
      validator: value => alertTypes.includes(value),
    },
    withIcon: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isDismissable() {
      return this.open !== null;
    },
  },
  methods: {
    handleDismiss() {
      this.$emit('update:open', false);
    },
  },
  created() {
    this.alertTypeToIcon = {
      [ALERT_WARNING]: 'warning',
      [ALERT_INFO]: 'info-fill',
      [ALERT_SUCCESS]: 'check-circle',
    };
  },
};
</script>
